import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, User } from 'lucide-react';

function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll('[data-reveal]');
    els.forEach(el => el.setAttribute('data-reveal-init', ''));
    const io = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); }),
      { threshold: 0.12 }
    );
    els.forEach(el => io.observe(el));
    const safety = setTimeout(() => els.forEach(el => el.classList.add('in')), 1500);
    return () => { io.disconnect(); clearTimeout(safety); };
  }, []);
}

export default function AboutPage() {
  useReveal();

  return (
    <main style={{ paddingTop: 100 }}>

      {/* ── Hero ── */}
      <section style={{ padding: '72px 0 0' }}>
        <div className="page-container">
          <p className="eyebrow eyebrow-gold animate-fade-up" style={{ marginBottom: 16 }}>
            About Us
          </p>
          <h1
            className="animate-fade-up delay-1"
            style={{
              fontFamily: 'var(--serif)',
              fontSize: 'clamp(40px, 7vw, 96px)',
              lineHeight: 0.98,
              textWrap: 'balance',
              maxWidth: 1000,
            }}>
            Contractor Rob Flooring
          </h1>

          <div
            style={{
              maxWidth: 820,
              marginTop: 56,
            }}
            data-reveal>

            <p style={{ fontFamily: 'var(--sans)', fontSize: 18, color: 'var(--ink-soft)', lineHeight: 1.7, marginBottom: 20 }}>
              Contractor Rob Flooring is wholly owned and distributed by Love3 Products, Inc., a Delaware
              Corporation. We utilize the latest technology, comprehensive equipment systems, and closed
              production processes with modern machinery.
            </p>

            <blockquote
              style={{
                fontFamily: 'var(--serif)',
                fontStyle: 'italic',
                fontSize: 24,
                color: 'var(--ink)',
                borderLeft: '3px solid var(--saffron)',
                paddingLeft: 28,
                margin: '32px 0',
                lineHeight: 1.4,
              }}>
              "We provide quality flooring, and that's a promise you can stand on."
            </blockquote>

            <p style={{ fontFamily: 'var(--sans)', fontSize: 16, color: 'var(--ink-soft)', lineHeight: 1.7, marginBottom: 20 }}>
              Love3 Products, Inc. is an American-owned company. As a core value, we believe love is the
              most powerful force in the universe. Our motto is: <em>"Love God, Love Your Neighbor, Love
              Yourself."</em>
            </p>

            <p style={{ fontFamily: 'var(--sans)', fontSize: 16, color: 'var(--ink-soft)', lineHeight: 1.7, marginBottom: 20 }}>
              The mission of Love3 Products is to make the world a better place, utilizing love as an agent
              of change. We spread love throughout the world by providing premium quality products, excellent
              customer service, fair pricing, and charitable initiatives. Starting with our leadership team
              and transcending all aspects of our company, we lead with love to better serve our customers
              and the greater community.
            </p>

            <p style={{ fontFamily: 'var(--sans)', fontSize: 16, color: 'var(--ink-soft)', lineHeight: 1.7 }}>
              We specialize in product development, design, manufacturing, and wholesale. We partner with
              independent wholesalers and retailers to develop a vast network of small and medium-sized
              business owners who share our vision and support our mission statement.
            </p>
          </div>
        </div>
      </section>

      {/* ── Mission band ── */}
      <section style={{ background: 'var(--ink)', padding: '96px 0', marginTop: 80 }}>
        <div className="page-container" style={{ textAlign: 'center' }}>
          <p
            className="eyebrow"
            style={{ color: 'var(--saffron)', marginBottom: 24 }}
            data-reveal>
            Our Mission
          </p>
          <h2
            style={{
              fontFamily: 'var(--serif)',
              fontSize: 'clamp(28px, 4vw, 56px)',
              color: 'var(--ivory)',
              maxWidth: 900,
              margin: '0 auto',
              textWrap: 'balance',
              lineHeight: 1.15,
            }}
            data-reveal>
            We lead with love
          </h2>
          <p
            style={{
              fontFamily: 'var(--sans)',
              fontSize: 16,
              color: 'rgba(255,255,255,0.6)',
              maxWidth: 640,
              margin: '20px auto 0',
              lineHeight: 1.7,
            }}
            data-reveal>
            Starting with our leadership team and transcending all aspects of our company, we lead with
            love to better serve our customers and the greater community.
          </p>
        </div>
      </section>

      {/* ── Meet Our CEO CTA ── */}
      <section style={{ padding: '80px 0' }}>
        <div className="page-container" style={{ textAlign: 'center' }} data-reveal>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 52,
              height: 52,
              borderRadius: '50%',
              background: 'var(--ivory-soft)',
              border: '1px solid var(--rule)',
              marginBottom: 20,
            }}>
            <User size={22} style={{ color: 'var(--saffron-deep)' }} />
          </div>
          <h2
            style={{
              fontFamily: 'var(--serif)',
              fontSize: 'clamp(28px, 4vw, 48px)',
              textWrap: 'balance',
              marginBottom: 12,
            }}>
            The person behind the brand
          </h2>
          <p
            style={{
              fontFamily: 'var(--sans)',
              fontSize: 16,
              color: 'var(--ink-soft)',
              maxWidth: 540,
              margin: '0 auto 32px',
              lineHeight: 1.65,
            }}>
            From the U.S. Navy to Southeast Asia—learn about the founder who built Contractor Rob
            Flooring from the ground up.
          </p>
          <Link to="/about/ceo" className="btn btn-primary btn-lg">
            Click Here to Learn More About Our CEO <ArrowRight size={14} />
          </Link>
        </div>
      </section>

    </main>
  );
}
